"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_transition_group_1 = require("react-transition-group");
var theme_1 = require("@prezzee/theme");
var utils_1 = require("@prezzee/utils");
function getScale(value) {
    return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}
var styles = {
    entering: {
        opacity: 1,
        transform: getScale(1),
    },
    entered: {
        opacity: 1,
        transform: 'none',
    },
};
/**
 * Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 * Remove this workaround once the WebKit bug fix is released.
 */
var isWebKit154 = typeof navigator !== 'undefined' &&
    /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) &&
    /(os |version\/)15(.|_)[4-9]/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */
var Grow = (0, react_1.forwardRef)(function (props, ref) {
    var addEndListener = props.addEndListener, _a = props.appear, appear = _a === void 0 ? true : _a, children = props.children, easing = props.easing, inProp = props.in, onEnter = props.onEnter, onEntered = props.onEntered, onEntering = props.onEntering, onExit = props.onExit, onExited = props.onExited, onExiting = props.onExiting, style = props.style, _b = props.timeout, timeout = _b === void 0 ? 'auto' : _b, refProp = props.ref, other = __rest(props, ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "ref"]);
    var timer = (0, react_1.useRef)();
    var autoTimeout = (0, react_1.useRef)();
    var theme = (0, theme_1.useTheme)();
    var nodeRef = (0, react_1.useRef)(null);
    // @ts-ignore
    var foreignRef = (0, utils_1.useForkRef)(children.ref, ref);
    var handleRef = (0, utils_1.useForkRef)(nodeRef, foreignRef);
    var normalizedTransitionCallback = function (callback) { return function (maybeIsAppearing) {
        if (callback) {
            var node = nodeRef.current;
            // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
            if (maybeIsAppearing === undefined) {
                callback(node);
            }
            else {
                callback(node, maybeIsAppearing);
            }
        }
    }; };
    var handleEntering = normalizedTransitionCallback(onEntering);
    var handleEnter = normalizedTransitionCallback(function (node, isAppearing) {
        (0, utils_1.reflow)(node); // So the animation always start from the start.
        var _a = (0, utils_1.getTransitionProps)({ style: style, timeout: timeout, easing: easing }, {
            mode: 'enter',
        }), transitionDuration = _a.duration, delay = _a.delay, transitionTimingFunction = _a.easing;
        var duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        }
        else {
            duration = transitionDuration;
        }
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay,
            }),
            theme.transitions.create('transform', {
                duration: isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction,
            }),
        ].join(',');
        if (onEnter) {
            onEnter(node, isAppearing);
        }
    });
    var handleEntered = normalizedTransitionCallback(onEntered);
    var handleExiting = normalizedTransitionCallback(onExiting);
    var handleExit = normalizedTransitionCallback(function (node) {
        var _a = (0, utils_1.getTransitionProps)({ style: style, timeout: timeout, easing: easing }, {
            mode: 'exit',
        }), transitionDuration = _a.duration, delay = _a.delay, transitionTimingFunction = _a.easing;
        var duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        }
        else {
            duration = transitionDuration;
        }
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay,
            }),
            theme.transitions.create('transform', {
                duration: isWebKit154 ? duration : duration * 0.666,
                delay: isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction,
            }),
        ].join(',');
        node.style.opacity = '0';
        node.style.transform = getScale(0.75);
        if (onExit) {
            onExit(node);
        }
    });
    var handleExited = normalizedTransitionCallback(onExited);
    var handleAddEndListener = function (next) {
        if (timeout === 'auto') {
            timer.current = setTimeout(next, autoTimeout.current || 0);
        }
        if (addEndListener) {
            // Old call signature before `react-transition-group` implemented `nodeRef`
            addEndListener(nodeRef.current, next);
        }
    };
    (0, react_1.useEffect)(function () {
        return function () {
            clearTimeout(timer.current);
        };
    }, []);
    return ((0, jsx_runtime_1.jsx)(react_transition_group_1.Transition, __assign({ appear: appear, in: inProp, nodeRef: nodeRef, onEnter: handleEnter, onEntered: handleEntered, onEntering: handleEntering, onExit: handleExit, onExited: handleExited, onExiting: handleExiting, addEndListener: handleAddEndListener, timeout: timeout === 'auto' ? undefined : timeout }, other, { ref: refProp }, { children: function (state, childProps) {
            return (0, react_1.cloneElement)(children, __assign({ style: __assign(__assign(__assign({ opacity: 0, transform: getScale(0.75), visibility: state === 'exited' && !inProp ? 'hidden' : undefined }, styles[state]), style), children.props.style), ref: handleRef }, childProps));
        } })));
});
exports.default = Grow;
//# sourceMappingURL=Grow.js.map